module.exports = __webpack_public_path__ + "static/media/boy3.322e162b.png";